import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { apiClient } from '../services/api'

type State = 'loading' | 'success' | 'error'

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''

  const [state, setState] = useState<State>('loading')
  const [verifiedEmail, setVerifiedEmail] = useState<string | null>(null)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)

  useEffect(() => {
    if (!token) {
      setErrorMessage('No verification token provided.')
      setState('error')
      return
    }
    // The API returns { email } on success, or an error with a message
    // (e.g. "This verification link is invalid or has expired").
    apiClient
      .verifyEmail(token)
      .then((result) => {
        setVerifiedEmail(result.email)
        setState('success')
      })
      .catch((err: unknown) => {
        setErrorMessage(
          err instanceof Error ? err.message : 'This verification link is invalid or has expired.'
        )
        setState('error')
      })
  }, [token])

  return (
    <div className="verify-page">
      {state === 'loading' && (
        <>
          <div className="spinner" />
          <p className="spinner-label">Verifying…</p>
        </>
      )}

      {state === 'success' && (
        <div className="verify-card">
          <div className="verify-icon">✓</div>
          <h2>Email verified</h2>
          <p>
            {verifiedEmail} is now verified. You can email <strong>save@eizel.co</strong> from this
            address to save content.
          </p>
          <Link to="/settings" className="btn-primary">
            Back to Settings
          </Link>
        </div>
      )}

      {state === 'error' && (
        <div className="verify-card">
          <div className="verify-icon">✗</div>
          <h2>Verification failed</h2>
          <p>{errorMessage}</p>
          <Link to="/settings" className="btn-secondary">
            Back to Settings
          </Link>
        </div>
      )}
    </div>
  )
}
